import { useCallback, useEffect, useState } from "react";

/**
 * Reports whether the reader has scrolled past a marker element, and scrolls
 * it back into view on request.
 *
 * Returns a callback ref for the marker, the flag, and `scrollToMarker`. An
 * observer is used instead of a scroll listener because the scroll container
 * differs by layout, and an observer against the viewport sees clipping by
 * any of them.
 */
export function useScrolledPast() {
  const [marker, setMarker] = useState(null);
  const [scrolledPast, setScrolledPast] = useState(false);

  useEffect(() => {
    if (!marker) return undefined;
    const observer = new IntersectionObserver(entries => {
      const entry = entries[entries.length - 1];
      setScrolledPast(!entry.isIntersecting);
    });
    observer.observe(marker);
    return () => observer.disconnect();
  }, [marker]);

  const scrollToMarker = useCallback(() => {
    marker?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [marker]);

  return { markerRef: setMarker, scrolledPast, scrollToMarker };
}
